export const handleFrontChat = (show: boolean) => {
	const frontChat = document?.getElementById('front-chat-iframe');
	if (frontChat) {
		frontChat.style.opacity = !show ? '0' : '1';
		frontChat.style.transform = !show ? 'translateY(-1000px)' : 'translateY(0)';
	}
};
